module.exports = __webpack_public_path__ + "static/media/id9-8-9-10.b163a81f.png";